<script type="text/jsx">
import { PREFIX_CLASS } from '@/utils/constants'
import { addClass, removeClass, hasClass } from '@/utils/helper'
const PREFIX_MENU_CLASS = `${PREFIX_CLASS}menu`
export default {
  name: 'TMenu',
  components: {
    't-menu-collapse-transition': {
      functional: true,
      render(createElement, context) {
        const data = {
          props: {
            mode: 'out-in'
          },
          on: {
            beforeEnter(el) {
              el.style.opacity = 0.2
            },

            enter(el) {
              addClass(el, 'menu-opacity-transition')
              el.style.opacity = 1
            },

            afterEnter(el) {
              removeClass(el, 'menu-opacity-transition')
              el.style.opacity = ''
            },

            beforeLeave(el) {
              if (!el.dataset) el.dataset = {}

              if (hasClass(el, 'menu--collapse')) {
                removeClass(el, 'menu--collapse')
                el.dataset.oldOverflow = el.style.overflow
                el.dataset.scrollWidth = el.clientWidth
                addClass(el, 'menu--collapse')
              } else {
                addClass(el, 'menu--collapse')
                el.dataset.oldOverflow = el.style.overflow
                el.dataset.scrollWidth = el.clientWidth
                removeClass(el, 'menu--collapse')
              }

              el.style.width = el.scrollWidth + 'px'
              el.style.overflow = 'hidden'
            },

            leave(el) {
              addClass(el, 'horizontal-collapse-transition')
              el.style.width = el.dataset.scrollWidth + 'px'
            }
          }
        }
        return createElement('transition', data, context.children)
      }
    }
  },
  props: {
    type: {
      type: String,
      default: 'light'
    },
    collapse: Boolean,
    collapseTransition: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: ''
    },
    openPosition: {
      type: String,
      validator(value) {
        return ['right', 'down'].includes(value)
      },
      default: 'down'
    },
    activeName: {
      type: [String, Number],
      default: ''
    },
    openNames: {
      type: Array,
      default() {
        return []
      }
    },
    accordion: {
      type: Boolean,
      default: false
    },
    router: Boolean
  },
  provide() {
    return {
      rootMenu: this
    }
  },
  data() {
    return {
      currentActiveName: this.activeName,
      openedMenus: this.openNames, // (this.openNames && !this.collapse) ? this.openNames.slice(0) : [],
      items: {},
      submenus: {},
      openedMenusCache: []
    }
  },
  computed: {
    classes() {
      return [
        `${PREFIX_MENU_CLASS}`,
        `${PREFIX_MENU_CLASS}--vertical`,
        `${PREFIX_MENU_CLASS}--${this.type}`,
        {
          [`${PREFIX_MENU_CLASS}--collapse horizontal-collapse-transition`]: this.collapse,
          [`horizontal-collapse-transition`]: this.collapseTransition
        }
      ]
    },
    styles() {
      let style = {
        width: this.width
      }
      return style
    }
  },
  watch: {
    collapse(newVal, oldVal) {
      if (oldVal === false && newVal === true) {
        this.openedMenusCache = [...this.openedMenus]
        this.openedMenus = []
      }
      if (oldVal === true && newVal === false) {
        this.openedMenus = [...this.openedMenusCache]
      }
    },
    activeName(newVal) {
      this.currentActiveName = newVal
    },
    openNames(newVal) {
      this.openedMenus = !this.collapse ? newVal : []
    }
  },
  mounted() {
  },
  methods: {
    /**
     * 更新激活菜单
     * @param val
     */
    $_updateActive(val) {
      const item = val || this.currentActiveName || this.activeName
      if (item) {
        this.currentActiveName = item
      } else {
        this.currentActiveName = ''
      }
      // 3.发送事件
      this.$emit('update:activeName', this.currentActiveName)
    },
    /**
     * 展开菜单
     */
    $_openMenu(submenu) {
      let openedMenus = this.openedMenus
      if (openedMenus.includes(submenu)) return
      // 将不在该菜单路径下的其余菜单收起
      if (this.accordion) {
        this.openedMenus = [submenu]
      } else {
        this.openedMenus.push(submenu)
      }
    },
    /**
     * 关闭菜单
     * @param index
     */
    $_closeMenu(index) {
      const i = this.openedMenus.indexOf(index)
      if (i !== -1) {
        this.openedMenus.splice(i, 1)
      }
    },
    /**
     * submenu展开或关闭回调
     * @param submenu
     */
    $_toggleSubmenu(submenu, isOpened = this.openedMenus.includes(submenu)) {
      if (isOpened) {
        this.$_closeMenu(submenu)
        this.$emit('menu-close', submenu)
      } else {
        this.$_openMenu(submenu)
        this.$emit('menu-open', submenu)
      }
      this.$emit('update:openNames', this.openedMenus)
    },
    /**
     * 点击 item 回调
     * @param item
     */
    $_handleItemClick(item) {
      // 1. 更新激活菜单
      this.$_updateActive(item)
      // 2. 是否跳转路由
      // if (this.router) {
      //   this.$_routeToItem(item, (error) => {
      //     if (error) console.error(error)
      //   })
      // }
      // 3.发送事件
      this.$emit('on-select', item)
    },
    /**
     * 路由导航
     * @param item
     * @param onError
     */
    $_routeToItem(item, onError) {
      let route = item.route || item.index
      try {
        this.$router.push(route, () => {}, onError)
      } catch (e) {
        console.error(e)
      }
    }

  },
  render (h) {
    const component = (
      <ul
        class={this.classes} style={this.styles}>
        {this.$scopedSlots.default({
          itemSelect: this.$_handleItemClick
        })}
      </ul>
    )
    if (this.collapseTransition) {
      return (
        <t-menu-collapse-transition>
          { component }
        </t-menu-collapse-transition>
      )
    } else {
      return component
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/menu/menu.vue